export const SETTINGS_SECTION_CLASSES = [
  'flex',
  'flex-col',
  'w-full',
  'space-y-8',
  '[&>h3]:mb-[10px]',
  '[&_label]:min-w-[280px]',
  '[&_label]:text-lightMode-gray-medium',
  'dark:[&_label]:text-darkMode-gray-light'
];

export const INPUT_BUTTON_GROUP_CLASSES = ['flex', 'space-x-2', 'md:items-end'];
